import { ref, computed } from 'vue';
import { t } from '@/utils/i18n-helper';
import store from '@/store';

export function usePerfilTabs() {
    const activeTab = ref('datos');

    const teatro = computed(() => store.getters.getTeatro);

    const tabs = computed(() => [
        {
            id: 'datos',
            label: t('perfil.datos_personales'),
            icon: 'person',
            shortLabel: t('perfil.datos')
        },
        {
            id: 'abonos',
            label: t('perfil.abonos', { abonos: teatro.value?.texto_abonos || 'Abonos' }),            
            icon: 'confirmation_number',
            shortLabel: t('perfil.abono', { abono: teatro.value?.texto_abonos || 'Abonos' })
        },
        {
            id: 'pedidos',
            label: t('perfil.pedidos'),
            icon: 'shopping_bag',
            shortLabel: t('perfil.pedidos')
        },
        {
            id: 'monedero',
            label: t('perfil.saldo'),
            icon: 'account_balance_wallet',
            shortLabel: t('perfil.saldo')
        },
        {
            id: 'info_pago',
            label: t('perfil.info_pago'),
            icon: 'credit_card',
            shortLabel: t('perfil.pagos')
        },
        {
            id: 'cantera',
            label: t('perfil.cantera'),
            icon: 'group',
            shortLabel: t('perfil.cantera')
        },
        {
            id: 'parcelas',
            label: t('home.parcelas'),
            icon: 'grid_on',
            shortLabel: t('home.parcelas')
        }
    ]);

    const changeTab = tabId => {
        activeTab.value = tabId;
        if (typeof window !== 'undefined' && window.innerWidth < 1024) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    const currentTab = computed(() => {
        return tabs.value.find(t => t.id === activeTab.value);
    });

    return {
        tabs,
        activeTab,
        currentTab,
        changeTab
    };
}